import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import { Text } from '@shared/components/text';
import { Head } from '@shared/components/head';
import Button from '@shared/components/md-design-system/Button/Button';
import { Icon } from '@ant-design/react-native';
import { colorPalette } from '@shared/config/colorsConfig';
import { CenteredModal } from '@shared/components/CenteredModal';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';

interface DeleteConfirmationModalProps {
  visible: boolean;
  documentName: string;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  visible,
  documentName,
  isDeleting,
  onConfirm,
  onCancel,
}) => {
  const { t } = dynamicTranslations();
  const s = 'history.documents.patientSection.deleteModal';

  return (
    <CenteredModal visible={visible} onClose={onCancel}>
      <View className="w-full bg-white rounded-2xl pt-5 pb-5 px-5">
        {/* Close button */}
        <TouchableOpacity onPress={onCancel} className="self-end mb-2">
          <Icon name="close" size={18} color={colorPalette.gray[500]} />
        </TouchableOpacity>

        {/* Warning icon */}
        <View
          className="w-14 h-14 rounded-full justify-center items-center self-center mb-4"
          style={{ backgroundColor: colorPalette.warning[100] }}
        >
          <Icon name="exclamation-circle" size={28} color={colorPalette.warning[500]} />
        </View>

        <Head type="h2" className="text-center mb-2">
          {t(`${s}.title`, { name: documentName })}
        </Head>

        <Text className="text-sm text-center mb-6" style={{ color: colorPalette.gray[500] }}>
          {t(`${s}.message`)}
        </Text>

        <View className="flex-row gap-3">
          <View className="flex-1">
            <Button variant="outline" onPress={onCancel} disabled={isDeleting}>
              {t(`${s}.cancel`)}
            </Button>
          </View>
          <View className="flex-1">
            <Button variant="danger" onPress={onConfirm} disabled={isDeleting}>
              {isDeleting ? t(`${s}.confirming`) : t(`${s}.confirm`)}
            </Button>
          </View>
        </View>
      </View>
    </CenteredModal>
  );
};
